import { render } from "./StandardTransportIn.vue?vue&type=template&id=1885fb41&scoped=true"
import script from "./StandardTransportIn.vue?vue&type=script&lang=js"
export * from "./StandardTransportIn.vue?vue&type=script&lang=js"

import "./StandardTransportIn.vue?vue&type=style&index=0&id=1885fb41&scoped=true&lang=css"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1885fb41"]])

export default __exports__